import script from "./Staff.vue?vue&type=script&setup=true&lang=js"
export * from "./Staff.vue?vue&type=script&setup=true&lang=js"

import "./Staff.vue?vue&type=style&index=0&id=3b0d04d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b0d04d9"]])

export default __exports__